module.exports = __webpack_public_path__ + "akne_5_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/akne_5_before.jpg
// module id = 924
// module chunks = 0